import $ from 'jquery';
import Ps from 'perfect-scrollbar';
import debounce from './utils/debounce';

class Header {
    constructor(mobileBreakpoint) {
        this.$document = $(document);
        this.$window = $(window);
        this.speed = 200;
        this.mobileBreakpoint = mobileBreakpoint;

        // Search
        this.$searchForm = $('.js-search-form');
        this.$searchField = $('.js-search-field');
        this.$searchToggleButton = $('.js-mobile-search');

        // Burger Menu
        this.$burgerButton = $('.js-mobile-menu');
        this.$burgerContent = $('.js-main-menu');
        this.$subMenus = $('.js-sub-menu');

        // -------
        this.$chevrons = $('.js-menu-item-expand');
        this.$activeSubmenu = $('.c-main-menu__item--level-1.current_page_item');
        // Search Events
        this.$searchToggleButton.on('click', $.proxy(this.toggleSearch, this));

        // Close search on doc click
        this.$document.on('click', $.proxy(this.documentClick, this));

        this.$document.keyup((e) => {
            // Escape Key
            if (e.keyCode === 27) {
                this.closeSearch();
                this.closeMenu();
                $('body, html').removeClass('u-scroll-locked');
            }
        });

        // Burger Events
        this.$burgerButton.on('click', $.proxy(this.burgerToggle, this));

        // Mobile Menu Events
        this.$chevrons.on('click', $.proxy(this.toggleMenu, this));

        this.$window.on('resize', debounce(() => {
            if (this.$window.width() > this.mobileBreakpoint) {
                this.resetEverything();
                this.destroyScrollbars();
            } else {
                this.addScrollbars();
                this.showSubmenu();
            }
        }, 300)).on('load', () => {
            if (this.$window.width() <= this.mobileBreakpoint) {
                this.addScrollbars();
                this.showSubmenu();
            }
        });

        // Scrollbars
        //----------------------------------------
        this.scrollbars = [];
    }

    addScrollbars() {
        this.destroyScrollbars();
        this.scrollbars.push(new Ps(this.$burgerContent[0], { swipeEasing: true }));
    }

    destroyScrollbars() {
        this.scrollbars.forEach((ps) => ps.destroy());
        this.scrollbars = [];
    }

    updateScrollbars() {
        this.scrollbars.forEach((ps) => ps.update());
    }

    documentClick(e) {
        // const $elem = $(e.target);
        //
        // if (!$elem.closest(this.$searchForm).length && !$elem.closest(this.$searchOpenButton).length) {
        //     this.closeSearch();
        // }
    }

    closeSearch() {
        if (this.$searchToggleButton.hasClass('mobile-menu--is-active')) {
            this.$searchToggleButton.removeClass('mobile-menu--is-active');
            this.$searchForm.fadeOut(this.speed);
            $('body, html').removeClass('u-scroll-locked');
            return true;
        }

        return false;
    }

    toggleSearch() {
        this.closeMenu();

        if (!this.closeSearch()) {
            this.$searchToggleButton.addClass('mobile-menu--is-active');

            this.$searchForm.fadeIn(this.speed, () => {
                this.$searchField.focus();
            });
            $('body, html').toggleClass('u-scroll-locked');
        }

    }

    closeMenu() {
        if (this.$burgerButton.hasClass('mobile-menu--is-active')) {
            this.$burgerButton.toggleClass('mobile-menu--is-active');

            this.$burgerContent.slideToggle(this.speed, () => {
                this.updateScrollbars();
            });

            $('body, html').removeClass('u-scroll-locked');
        }
    }

    toggleMenu(e) {
        e.preventDefault();

        const $elem = $(e.currentTarget);

        $elem.toggleClass('is-open');
         $elem.next().slideToggle(this.speed, () => {
             this.updateScrollbars();
         });
    }

    burgerToggle() {
        this.closeSearch();
        this.$burgerButton.toggleClass('mobile-menu--is-active');

        this.$burgerContent.slideToggle(this.speed, () => {
            this.updateScrollbars();
        });

        $('body, html').toggleClass('u-scroll-locked');
    }

    showSubmenu() {
        if(this.$activeSubmenu.length > 0) {
            this.$activeSubmenu.parents('.c-main-menu__item')
                .find('.js-menu-item-expand').click();
        }
    }


    resetEverything() {
        // Reset Burger Menu
        this.$burgerButton.removeClass('mobile-menu--is-active');
        this.$burgerContent.removeAttr('style');
        this.$subMenus.removeAttr('style');
        this.$searchForm.removeAttr('style');

        $('body, html').removeClass('u-scroll-locked');
    }


}

export default Header;
